import React from "react";
import useRefunds from "../hooks/useRefunds";
import { formatINR } from "../utils/formatINR";

const Refunds = () => {
  const { refunds, isLoading, error, message, refetch } = useRefunds();

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white shadow-sm border-b">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center py-4">
            <h1 className="text-xl font-semibold text-gray-900">
              Refund Transactions
            </h1>
            <button
              onClick={refetch}
              className="px-4 py-2 text-sm font-medium bg-black text-white rounded-lg hover:bg-gray-800"
            >
              Refresh
            </button>
          </div>
        </div>
      </header>

      {/* Body */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
        {isLoading && <p className="text-gray-500">Loading refunds...</p>}
        {error && <p className="text-red-500">{error}</p>}
        {message && <p className="text-gray-600">{message}</p>}

        <div className="space-y-4">
          {refunds.length === 0 && !isLoading && (
            <p className="text-gray-500">No refunds found.</p>
          )}

          {refunds.map((refund, idx) => (
            <div
              key={idx}
              className="bg-white shadow rounded-xl p-4 flex flex-col sm:flex-row sm:justify-between sm:items-center border"
            >
              {/* Left info */}
              <div className="flex-1 space-y-1">
                <p className="text-sm font-medium text-gray-900">
                  Refund ID: <span className="text-gray-700">{refund.refund_id}</span>
                </p>
                <p className="text-sm font-medium text-gray-900">
                  Station: <span className="text-gray-700">{refund.station_name}</span>
                </p>
                <p className="text-sm text-gray-600">
                  Vehicle ID: {refund.vehicle_id}
                </p>
              </div>

              {/* Right info */}
              <div className="mt-2 sm:mt-0 text-sm text-gray-700 text-right space-y-1">
                <p className="font-medium">{formatINR(refund.refund_amount)}</p>
                <p>
                  Status:{" "}
                  <span
                    className={`px-2 py-0.5 rounded text-xs ${
                      refund.status === "processed"
                        ? "bg-green-100 text-green-700"
                        : refund.status === "pending"
                        ? "bg-yellow-100 text-yellow-700"
                        : "bg-red-100 text-red-700"
                    }`}
                  >
                    {refund.status}
                  </span>
                </p>
                <p className="text-gray-500 text-xs">
                  {new Date(refund.created_at).toLocaleString()}
                </p>
              </div>
            </div>
          ))}
        </div>
      </main>
    </div>
  );
};

export default Refunds;
